import "./App.css";
import React, { useEffect } from "react";
import {
  RouterProvider
} from 'react-router-dom';
import { setDefaultHeader } from "./utils/httpClient";
import Routes from './route';
import { loadFromLocalStorage, saveToLocalStorage } from "./utils/LocalStorageUtils";
import languages from "translations";
import { isEmpty } from "utils/utils";
function App() {
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  useEffect(() => {
    const authData = loadFromLocalStorage("AUTH_DATA");
    if (authData?.token) {
      setDefaultHeader("token", authData.token)
    }
    if (selectLang != undefined && isEmpty(selectLang)) {
      const lang = {
        language: languages.english,
        langCode: 'en',
      }
      saveToLocalStorage("SELECTLANGUAGE", lang);
    }
  }, []);

  // return <RouterProvider router={Routes} />
  return <RouterProvider router={Routes} />
}

export default App;